'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NAME_SPACE = '@app/';

var GET_APP = exports.GET_APP = NAME_SPACE + 'GET_APP';
var TOGGLE_TUTORIAL = exports.TOGGLE_TUTORIAL = NAME_SPACE + 'TOGGLE_TUTORIAL';


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/App/types.js
// module id = 119
// module chunks = 0